(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.sectionHeader = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky && this.sectionHeader) this.sectionHeader.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      const el = document.querySelector('.section-header');
      if (el) document.documentElement.style.setProperty('--header-height', el.offsetHeight + 'px');
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      const target = this.sectionHeader || document.body;
      new IntersectionObserver((entries, obs) => { this.headerBounds = entries[0].intersectionRect; obs.disconnect(); }).observe(target);
    }
    onScroll() {
      const s = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      const bottom = this.headerBounds.bottom || 100;
      const top    = this.headerBounds.top    || 0;
      if (s > this.currentScrollTop && s > bottom) {
        if (!this.preventHide) requestAnimationFrame(this.hide.bind(this));
      } else if (s < this.currentScrollTop && s > bottom) {
        if (!this.preventReveal) requestAnimationFrame(this.reveal.bind(this));
        else { window.clearTimeout(this.isScrolling); this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66); requestAnimationFrame(this.hide.bind(this)); }
      } else if (s <= top) { requestAnimationFrame(this.reset.bind(this)); }
      this.currentScrollTop = s;
    }
    hide()   { if (this.headerIsAlwaysSticky || !this.sectionHeader) return; this.sectionHeader.classList.add('shopify-section-header-hidden','shopify-section-header-sticky'); }
    reveal() { if (this.headerIsAlwaysSticky || !this.sectionHeader) return; this.sectionHeader.classList.add('shopify-section-header-sticky','animate'); this.sectionHeader.classList.remove('shopify-section-header-hidden'); }
    reset()  { if (this.headerIsAlwaysSticky || !this.sectionHeader) return; this.sectionHeader.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky','animate'); }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
